<mat-progress-bar #progressBar [color]="color" [value]="100" mode="determinate"></mat-progress-bar>
